var _circle, _circle2, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProjectionDaysEndGoal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#FFD8D8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 15.5,
    stroke: "#D91F05"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 33,
    width: 10,
    height: 1,
    rx: 0.5,
    fill: "#D91F05"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 34,
    width: 10,
    height: 1,
    rx: 0.5,
    transform: "rotate(-90 30 34)",
    fill: "#D91F05"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectionDaysEndGoal);
export default __webpack_public_path__ + "static/media/projection_days_end_goal.b1841efdeb4297c0174408dafb92ba60.svg";
export { ForwardRef as ReactComponent };